<template>
  <div ref="myDualSlider" class="dual-range-container">
    <div :id="'my-dual-slider-' + compid" :se-min="value[0]" :se-step="step" :se-min-value="value[0]" :se-max-value="value[1]" :se-max="value[1]" class="dual-range-slider">
      <div class="slider-touch-left">
        <span />
      </div>
      <div class="slider-touch-right">
        <span />
      </div>
      <div class="slider-line">
        <span />
      </div>
    </div>
    <div class="slider-show-output">{{ formatValue(showval[0]) }} - {{ formatValue(showval[1]) }}</div>
    <div class="marker marker-0">{{ formatValue(scale_slider[0]) }}</div>
    <div class="marker marker-25">{{ formatValue(scale_slider[1]) }}</div>
    <div class="marker marker-50">{{ formatValue(scale_slider[2]) }}</div>
    <div class="marker marker-75">{{ formatValue(scale_slider[3]) }}</div>
    <div class="marker marker-100">{{ formatValue(scale_slider[4]) }}</div>
  </div>
</template>

<script>
export default {
  name: 'DualSlider',
  props: {
    value: {
      type: Array,
      default: () => [0, 100]
    },
    step: {
      type: Number,
      default: 1
    },
    limitprefixLower: {
      type: String,
      default: ''
    },
    limitprefixUpper: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      compid: null,
      rangeSlider: null,
      scale_slider: [],
      showval: [],
      element: null
    }
  },
  watch: {
    value: function() {
      var vm = this
      vm.calculateLimits()
      if (vm.step < 1) {
        vm.rangeSlider.setRanges(parseFloat(vm.value[0]), parseFloat(vm.value[1]))
        vm.rangeSlider.setMinValue(parseFloat(vm.value[0]))
        vm.rangeSlider.setMaxValue(parseFloat(vm.value[1]))
        vm.formatShowValue(vm.value[0], vm.value[1])
      } else {
        vm.rangeSlider.setRanges(Math.trunc(vm.value[0]), Math.round(vm.value[1]))
        vm.rangeSlider.setMinValue(Math.trunc(vm.value[0]))
        vm.rangeSlider.setMaxValue(Math.round(vm.value[1]))
        vm.formatShowValue(Math.trunc(vm.value[0]), Math.round(vm.value[1]))
      }
      vm.rangeSlider.reset()
      vm.rangeSlider.resizeLabel()
    }
  },
  mounted() {
    var vm = this
    vm.compid = vm._uid
    vm.element = vm.$refs.myDualSlider
    vm.rangeSlider = new this.InitializeSlider(vm.element)
    if (vm.step < 1) vm.formatShowValue(vm.value[0], vm.value[1])
    else vm.formatShowValue(Math.trunc(vm.value[0]), Math.round(vm.value[1]))
    vm.calculateLimits()
    vm.rangeSlider.onChange = function(min, max) {
      vm.formatShowValue(min, max)
      vm.$emit('input', [min, max])
    }
  },
  methods: {
    formatShowValue(val1, val2) {
      var vm = this
      var res = []
      if (parseFloat(vm.value[0]) === parseFloat(val1)) res.push((vm.limitprefixLower + val1))
      else res.push(val1)
      if (parseFloat(vm.value[1]) === parseFloat(val2)) res.push((vm.limitprefixUpper + val2))
      else res.push(val2)
      vm.showval = res
    },
    formatValue(val) {
      if (val === undefined || val === null) { return 0 }
      return val.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    InitializeSlider: function(ele) {
      var self = this
      var startX = 0; var x = 0

      // retrieve touch button
      var slider = ele.querySelector('.dual-range-slider')
      var touchLeft = slider.querySelector('.slider-touch-left')
      var touchRight = slider.querySelector('.slider-touch-right')
      var lineSpan = slider.querySelector('.slider-line span')
      var resultDiv = ele.querySelector('.slider-show-output')
      var container = ele

      // get some properties
      var min = parseFloat(slider.getAttribute('se-min'))
      var max = parseFloat(slider.getAttribute('se-max'))

      // retrieve default values
      var defaultMinValue = min
      if (slider.hasAttribute('se-min-value')) {
        defaultMinValue = parseFloat(slider.getAttribute('se-min-value'))
      }
      var defaultMaxValue = max
      if (slider.hasAttribute('se-max-value')) {
        defaultMaxValue = parseFloat(slider.getAttribute('se-max-value'))
      }

      // check values are correct
      if (defaultMinValue < min) {
        defaultMinValue = min
      }

      if (defaultMaxValue > max) {
        defaultMaxValue = max
      }

      if (defaultMinValue > defaultMaxValue) {
        defaultMinValue = defaultMaxValue
      }

      var step = 0.0

      if (slider.getAttribute('se-step')) {
        step = Math.abs(parseFloat(slider.getAttribute('se-step')))
      }

      // normalize flag
      var normalizeFact = 22

      self.slider = slider
      self.reset = function() {
        touchLeft.style.left = '0px'
        touchRight.style.left = (slider.offsetWidth - touchLeft.offsetWidth) + 'px'
        lineSpan.style.marginLeft = '0px'
        lineSpan.style.width = (slider.offsetWidth - touchLeft.offsetWidth) + 'px'
        startX = 0
        x = 0
      }

      self.setRanges = function(minV, maxV) {
        min = parseFloat(minV)
        max = parseFloat(maxV)
        slider.setAttribute('se-min-value', min)
        slider.setAttribute('se-max-value', max)
      }

      self.setMinValue = function(minValue) {
        var ratio = ((minValue - min) / (max - min))
        touchLeft.style.left = Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact))) + 'px'
        lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px'
        lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px'
        slider.setAttribute('se-min-value', minValue)
      }

      self.setMaxValue = function(maxValue) {
        var ratio = ((maxValue - min) / (max - min))
        touchRight.style.left = Math.ceil(ratio * (slider.offsetWidth - (touchLeft.offsetWidth + normalizeFact)) + normalizeFact) + 'px'
        lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px'
        lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px'
        slider.setAttribute('se-max-value', maxValue)
      }

      self.resizeLabel = function() {
        resultDiv.style.left = ((lineSpan.offsetLeft + (container.offsetWidth * 0.05) + (lineSpan.offsetWidth / 2)) - (resultDiv.offsetWidth / 2)) + 'px'
      }

      // initial reset
      self.reset()
      self.resizeLabel()

      // usefull values, min, max, normalize fact is the width of both touch buttons
      var maxX = slider.offsetWidth - touchRight.offsetWidth
      var selectedTouch = null
      var initialValue = (lineSpan.offsetWidth - normalizeFact)

      // set defualt values
      self.setMinValue(defaultMinValue)
      self.setMaxValue(defaultMaxValue)

      // setup touch/click events
      function onStart(event) {
        // Prevent default dragging of selected content
        event.preventDefault()
        var eventTouch = event

        if (event.touches) {
          eventTouch = event.touches[0]
        }

        if (this === touchLeft) {
          x = touchLeft.offsetLeft
        } else {
          x = touchRight.offsetLeft
        }

        startX = eventTouch.pageX - x
        selectedTouch = this
        document.addEventListener('mousemove', onMove)
        document.addEventListener('mouseup', onStop)
        document.addEventListener('touchmove', onMove)
        document.addEventListener('touchend', onStop)
      }

      function onMove(event) {
        var eventTouch = event

        if (event.touches) {
          eventTouch = event.touches[0]
        }

        x = eventTouch.pageX - startX

        if (selectedTouch === touchLeft) {
          if (x > (touchRight.offsetLeft - selectedTouch.offsetWidth - 2)) {
            x = (touchRight.offsetLeft - selectedTouch.offsetWidth - 2)
          } else if (x < 0) {
            x = 0
          }

          selectedTouch.style.left = x + 'px'
        } else if (selectedTouch === touchRight) {
          if (x < (touchLeft.offsetLeft + touchLeft.offsetWidth + 2)) {
            x = (touchLeft.offsetLeft + touchLeft.offsetWidth + 2)
          } else if (x > maxX) {
            x = maxX
          }
          selectedTouch.style.left = x + 'px'
        }

        // update line span
        lineSpan.style.marginLeft = touchLeft.offsetLeft + 'px'
        lineSpan.style.width = (touchRight.offsetLeft - touchLeft.offsetLeft) + 'px'

        // write new value
        calculateValue()

        // call on change
        if (slider.getAttribute('on-change')) {
          var fn = new Function('min, max', slider.getAttribute('on-change'))
          fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'))
        }

        if (self.onChange) {
          self.onChange(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'))
        }
        // update result div
        resultDiv.style.left = ((touchLeft.offsetLeft + (container.offsetWidth * 0.05) + ((touchRight.offsetLeft - touchLeft.offsetLeft) / 2)) - (resultDiv.offsetWidth / 2)) + 'px'
      }

      function onStop(event) {
        document.removeEventListener('mousemove', onMove)
        document.removeEventListener('mouseup', onStop)
        document.removeEventListener('touchmove', onMove)
        document.removeEventListener('touchend', onStop)

        selectedTouch = null

        // write new value
        calculateValue()

        // call did changed
        if (slider.getAttribute('did-changed')) {
          var fn = new Function('min, max', slider.getAttribute('did-changed'))
          fn(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'))
        }

        if (self.didChanged) {
          self.didChanged(slider.getAttribute('se-min-value'), slider.getAttribute('se-max-value'))
        }
      }

      function calculateValue() {
        var newValue = (lineSpan.offsetWidth - normalizeFact) / initialValue
        var minValue = lineSpan.offsetLeft / initialValue
        var maxValue = minValue + newValue

        minValue = minValue * (max - min) + min
        maxValue = maxValue * (max - min) + min

        if (step !== 0.0) {
          var multi = Math.floor((minValue / step))
          minValue = step * multi

          multi = Math.floor((maxValue / step))
          maxValue = step * multi
        }

        slider.setAttribute('se-min-value', minValue)
        slider.setAttribute('se-max-value', maxValue)
      }

      // link events
      touchLeft.addEventListener('mousedown', onStart)
      touchRight.addEventListener('mousedown', onStart)
      touchLeft.addEventListener('touchstart', onStart)
      touchRight.addEventListener('touchstart', onStart)
    },
    calculateLimits() {
      var min = parseFloat(this.value[0])
      var max = parseFloat(this.value[1])

      var diff = max - min
      this.scale_slider = []
      for (let i = 0; i <= 1; i = i + 0.25) {
        if (i === 0) { this.scale_slider.push(Math.trunc((diff * i) + min)) } else { this.scale_slider.push(Math.round((diff * i) + min)) }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dual-range-container {
  font-family: 'Montserrat-Regular',sans-serif;
  position: relative;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.dual-range-slider {
	display: block;
	position: relative;
	height: 20px;
	width: 100%;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select:none;
	-o-user-select:none;
	user-select:none;

	.slider-touch-left, .slider-touch-right {
		display: block;
		position: absolute;
		height: 20px;
		width: 20px;
		z-index: 2;
    cursor: pointer;

		span {
			display: block;
			width: 100%;
			height: 100%;
			background: white;
			border: 3px solid #1e3cff;
			border-radius: 50%;
		}
	}

	.slider-line {
		position: absolute;
		width: 90%;
    left: 5%;
		top: 8px;
		height: 4px;
		border-radius: 4px;
		background: #e0e0e0;
		z-index: 1;
		overflow: hidden;

		span {
			display: block;
			height: 100%;
			width: 0%;
			background: #1e3cff;
		}
	}
}

.marker {
  position: absolute;
  bottom: 0;
  font-size: 9px;
  color: #999;
  transform: translateX(-50%);

  &:after{
    bottom: 14px;
    content: '';
    width: 3px;
    height: 12px;
    background: #e0e0e0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.marker-0{
  left: 5%;
}

.marker-25{
  left: 27.5%;
}

.marker-50{
  left: 50%;
}

.marker-75{
  left: 72.5%;
}

.marker-100{
  left: 95%;
}

.slider-show-output {
  position: absolute;
  top: 1px;
  font-size: 9.5px;
  left: 50%;
  font-weight: bold;
  width: fit-content;
}
</style>
